import { useMutation, useQueryClient } from '@tanstack/react-query';
import { refreshBillingReconciliationVarianceClassifications } from './billingReconciliationVarianceRefreshApi.js';
import {
  invalidateBillingBacContext,
  invalidateBillingVarianceLists,
} from './billingReconciliationQueryInvalidation.js';

export const useRefreshBillingReconciliationVarianceClassifications = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: refreshBillingReconciliationVarianceClassifications,
    onSuccess: (data, variables) => {
      if (data?.dryRun) return;
      invalidateBillingVarianceLists(queryClient, { runId: variables?.runId });
      invalidateBillingBacContext(queryClient, { runId: variables?.runId });
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'runs'] });
    },
  });
};
